(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hexo-faq"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const buttons = root.querySelectorAll('.cat-btn');
    const sections = root.querySelectorAll('.cat-section');
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        buttons.forEach((item) => item.classList.remove('active'));
        sections.forEach((section) => section.classList.remove('active'));
        button.classList.add('active');
        root.querySelector(`#cat-${button.dataset.cat}`)?.classList.add('active');
      });
    });
    root.querySelectorAll('.faq-q').forEach((question) => {
      question.setAttribute('role', 'button');
      question.setAttribute('tabindex', '0');
      question.setAttribute('aria-expanded', 'false');
      const toggle = () => {
        const item = question.parentElement;
        const wasOpen = item.classList.contains('open');
        item.closest('.faq-list').querySelectorAll('.faq-item').forEach((faqItem) => {
          faqItem.classList.remove('open');
          faqItem.querySelector('.faq-q')?.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          item.classList.add('open');
          question.setAttribute('aria-expanded', 'true');
        }
      };
      question.addEventListener('click', toggle);
      question.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggle();
        }
      });
    });
  };
  document.querySelectorAll('.hexo-source-page--hexo-faq').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target.querySelector('.hexo-source-page--hexo-faq'));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hexo-footer"]) return;
  try {
    
  if (!customElements.get('hexo-refined-footer')) {
    customElements.define('hexo-refined-footer', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.mobile = window.matchMedia('(max-width:749px)');
        this.sync = () => this.querySelectorAll('.hx-footer-group').forEach(group => { group.open = !this.mobile.matches; });
        this.sync();
        this.mobile.addEventListener('change', this.sync, { signal:this.controller.signal });
        this.addEventListener('click', event => {
          if (!this.mobile.matches && event.target.closest('.hx-footer-group summary')) event.preventDefault();
        }, { signal:this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hexo-jewelry-guide"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    root.querySelectorAll('.nav-item').forEach((item, index) => {
      item.setAttribute('role', 'button');
      item.setAttribute('tabindex', '0');
      const navigate = () => root.querySelector(`#s${index + 1}`)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      item.addEventListener('click', navigate);
      item.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          navigate();
        }
      });
    });
  };
  document.querySelectorAll('.hexo-source-page--hexo-jewelry-guide').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target.querySelector('.hexo-source-page--hexo-jewelry-guide'));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
